const APIKEY = "99d579bcaaccb6c72bf5278c4adc5849";
const APIID = "e5dc878c";

export { APIKEY, APIID };